<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item>
          <a href="javascript:void(0);" class="aHref" @click="$router.push({name: 'exam'})">心理测试</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>测试详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail">
        <div class="leftCon ">
          <h2>{{ detail.title }}</h2>
          <span class="description">{{ detail.subTitle }}</span>
          <img :src="detail.exhibitImg" alt="" class="detailImg">
          <p class="content">{{ detail.briefDesc }}</p>
          <div class="notice flex">
            <span class="tit">测试须知</span>
            <div class="question">
              <p><span>题目数：</span><span>{{ detail.subjectCount }}题</span></p>
              <p><span>预计时长：</span><span>{{ detail.exceptTime }}</span></p>
            </div>
            <div style="width: 32%; text-align: center;">
              <div>
                <el-button v-if="isLogin" class="start-btn" type="primary" plain @click="startAnswer">开始答题</el-button>
                <el-button v-else class="login-btn" type="primary" plain @click="openLoginDialog">登录后查看详细信息</el-button>
              </div>
            </div>
          </div>
          <div class="comment" v-for="(obj,ind) in msgList" :key="ind">
            <el-avatar v-if="obj.isAnonymous==0 && obj.userAvatar" :src="obj.userAvatar" shape="circle" :size="50"></el-avatar>
            <el-avatar v-else icon="el-icon-user-solid" shape="circle" :size="50"></el-avatar>
            <div>
              <h2>{{ obj.userName }}</h2>
              <p>{{ obj.msgDate }}</p>
              <p>{{ obj.msgContent }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <loginDialog ref="loginDialog"></loginDialog>
  </div>
</template>

<script>
import base from '@/api/common';
import loginDialog from "../loginDialog";

export default {
  name: "exam_corp_detail",
  data() {
    return {
      detail: {
        subjectCount: 10,
        exceptTime: '约1分钟'
      },
      dialogVisible: false,
      id: this.$route.query.id,
      msgList: [],
      isLogin: false,
    }
  },
  components: {loginDialog},
  inject: ['reload'],
  async mounted() {
    if (this.id === null) {
      this.$router.back();
    }
    let curUser = await base.utils.getCurrent();
    if(curUser){
      this.isLogin = true;
      this.getData(this.id);
    }else{
      this.openLoginDialog();
    }
  },
  methods: {
    openLoginDialog(){
      this.$refs.loginDialog.dialogVisible = true;
      this.$refs.loginDialog.reloadCode('vcode-user');
    },
    getData(id) {
      // id: corp id
      this.$ajax.get(base.basePath + 'corp/corp-exam/authorize/details-exam/' + id).then((res) => {
        if (res.data.status === 'success') {
          this.detail = res.data.data.exam;
          // load msg
          let examId = res.data.data.exam.id;
          this.$ajax.get(base.api.exam.message.list.replace("{id}", examId), {params: {page: 1, size: 5}}).then((res) => {
            if (res.data.status === 'success') {
              this.msgList = res.data.rows;
            }
          });
        } else {
          this.$messageBox.alert(res.data.message,{type: 'error'});
        }
      });

    },
    startAnswer() {
      if(!this.isLogin){
        this.openLoginDialog();
        return;
      }
      let examId = this.detail.id;
      if(!examId){this.$message.error('无法获取信息');return;}
      this.$ajax.post(base.basePath + 'corp/corp-exam/authorize/partake/' + this.id).then(res=>{
        if(res.data.status === 'success'){
          this.$router.push({name: 'examQuestion', query: {id: examId}});
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        console.error(err);
        this.$message.error('错误,请稍后再试');
      });

    },

  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/psychological.scss";

.aHref {
  font-size: 13px;
  color: #999999;
  font-weight: 400;
}

.expireMask {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  background: #ccc;
  opacity: 0.8;
  color: #FFF;

  .text {
    margin: 32% auto;
    font-size: 20px;
    font-weight: bold;
    width: 130px;
    background: #000;
  }
}
.detail {
  .detailImg{
    max-height: 300px;
    max-width: 400px;
  }
}
.start-btn{
  height: 70px;
  line-height: 70px;
  width: 180px;
  font-size: 20px;
  padding: 0;
}

</style>
